import asyncActionTypes from './types.js';

export const validateSession = ( userToken ) => {
  return {
    type: asyncActionTypes.SESSION_CHECKER,
    userToken,
  };
};

export const userProfileLogout = ( userToken ) => {
  return {
    type: asyncActionTypes.USER_LOGOUT,
    userToken,
  };
};

export const activeBannerUpdateConsent = ( activate, isSuccess ) => {
  return {
    type: asyncActionTypes.ACTIVE_BANNER,
    activate,
    isSuccess,
  };
};

export const setTokenInvalidSecurity = ( ffNumber, tokenWasInvalid ) => {
  return {
    type: asyncActionTypes.TOKEN_INVALID_SECURITY,
    ffNumber,
    tokenWasInvalid,
  };
};

export const clearTokenInvalidSecurity = () => {
  return {
    type: asyncActionTypes.TOKEN_INVALID_SECURITY,
    ffNumber: '',
    tokenWasInvalid: false,
  };
};

export const setPendingOpenModalLogin = ( pendingOpen ) => {
  return {
    type: asyncActionTypes.PENDING_OPEN_MODAL_LOGIN,
    pendingOpen,
  };
};